"use strict";

exports.__esModule = true;
exports.getEstimateRemoveLiquidityResult = getEstimateRemoveLiquidityResult;
var _sdkCore = require("@acala-network/sdk-core");
function getEstimateRemoveLiquidityResult(poolDetail, removeShare, slippage) {
  const {
    share: totalShare,
    amounts,
    info: {
      token
    }
  } = poolDetail;
  const ratio = removeShare.mul(new _sdkCore.FixedPointNumber(1 - slippage, token.decimals)).div(totalShare);
  if (!ratio.isPositive()) return {
    poolDetail,
    removeShare,
    minReceived: [_sdkCore.FixedPointNumber.ZERO, _sdkCore.FixedPointNumber.ZERO],
    slippage
  };
  return {
    poolDetail,
    removeShare,
    minReceived: [amounts[0].mul(ratio), amounts[1].mul(ratio)],
    slippage
  };
}